import { CANCEL_PAYMENT_LINK } from "resources/actionTypes";

export function cancelPaymentLink(tripId) {
  return {
    type: CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_REQUESTED,
    payload: { tripId },
  };
}
